import React from 'react';

import { graphql, PageProps } from 'gatsby';

import { Market } from '@mewa/types';
import { BreadCrumbData } from '@mewa/ui';

import t from '../../../libs/translate';
import { NavigationData } from '../../components/header/types';
import { getServiceSegmentImage } from '../../components/home/service-segment-images';
import { GlobalPageContext } from '../../types';
import { CategoryPage } from './category-page';
import { CategoryPageContentType } from './types';

export { Head } from '../../layouts/head';

type Props = NavigationData & {
  translations: {
    seo_footer_show_more_label: string;
    seo_footer_show_less_label: string;
    general_more_information: string;
    general_form_button_label_back: string;
    general_form_button_label_next: string;
    navigation_product_menu_label: string;
    general_consultation_cta: string;
  };
  strapiClothingCategoryPage: {
    content: CategoryPageContentType;
  };
};

type PageContext = GlobalPageContext & {
  id: string;
  market: Market;
};

export const query = graphql`
  query ($lang: String!, $locale: String!) {
    ...NavigationFragment

    translations: translation(locale: { eq: $locale }) {
      seo_footer_show_more_label
      seo_footer_show_less_label
      general_more_information
      general_form_button_label_back
      general_form_button_label_next
      navigation_product_menu_label
      general_consultation_cta
    }

    strapiClothingCategoryPage(locale: { eq: $locale }) {
      content: CategoryPage {
        ...CategoryPageContentFragment
      }
    }
  }
`;

export const ClothingCategory = ({
  data: {
    navigationClothing: { nodes: serviceSegments },
    translations,
    navigationLinks,
    contactTeaserLabels,
    strapiClothingCategoryPage,
  },
  pageContext,
}: PageProps<Props, PageContext>) => {
  const serviceSegmentItems = serviceSegments.map((s) => ({
    ...s,
    image: getServiceSegmentImage(s.assets.default, s.name),
  }));

  const breadCrumbData: BreadCrumbData[] = [
    {
      name: t(translations, 'navigation_product_menu_label'),
      slug: `${pageContext.langPrefix}/${navigationLinks.navigation.productMenu.slug}/`,
    },
    {
      name: navigationLinks.navigation.clothing.name,
      slug: '',
    },
  ];

  const mobileBreadCrumbData: BreadCrumbData = {
    name: t(translations, 'navigation_product_menu_label'),
    slug: `${pageContext.langPrefix}/${navigationLinks.navigation.productMenu.slug}/`,
  };

  return (
    <CategoryPage
      pageContext={pageContext}
      items={serviceSegmentItems}
      categoryPageContent={strapiClothingCategoryPage.content}
      translations={translations}
      navigationLinks={navigationLinks}
      breadCrumbData={breadCrumbData}
      mobileBreadCrumbData={mobileBreadCrumbData}
      seoFooter={{
        html: strapiClothingCategoryPage.content.seo.data.childMarkdownRemark
          .html,
        showMoreLabel: t(translations, 'seo_footer_show_more_label'),
        showLessLabel: t(translations, 'seo_footer_show_less_label'),
      }}
      contactTeaserLabels={contactTeaserLabels}
    />
  );
};

ClothingCategory.noContactTeaser = true;

export default ClothingCategory;
